import { FC, useMemo } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";

import { useGetMyPermissionsQuery } from "../../../entities/me";
import { AdminContent } from "../../../widgets/admin-content";
import {
  getDefaultNavItem,
  isAdminContentType,
} from "../model/admin-menu-items";

export const AdminHomeRedirect: FC = () => {
  const {
    data: permissionsData,
    isLoading,
    error,
  } = useGetMyPermissionsQuery();

  const permissions = useMemo(
    () => permissionsData?.permissions || [],
    [permissionsData],
  );

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <Typography color="error">Ошибка загрузки разрешений</Typography>
      </Box>
    );
  }

  const defaultItem = getDefaultNavItem(permissions);

  if (!defaultItem) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <Typography>У вас нет доступа к административной панели</Typography>
      </Box>
    );
  }

  return <Navigate to={defaultItem.path} replace />;
};

export const Home: FC = () => {
  const { section } = useParams<{ section: string }>();
  const {
    data: permissionsData,
    isLoading,
    error,
  } = useGetMyPermissionsQuery();

  const permissions = useMemo(
    () => permissionsData?.permissions || [],
    [permissionsData],
  );

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <Typography color="error">Ошибка загрузки разрешений</Typography>
      </Box>
    );
  }

  if (!section || !isAdminContentType(section)) {
    const fallback = getDefaultNavItem(permissions);
    return <Navigate to={fallback?.path || "/"} replace />;
  }

  return (
    <Box sx={{ height: "100%", minWidth: 0 }}>
      <AdminContent selectedContent={section} permissions={permissions} />
    </Box>
  );
};
